module.exports = __webpack_public_path__ + "img/Wassertruppmann.dbba828e.svg";